export default __webpack_public_path__ + "static/media/codetective.d034853a.jpeg";